import {LayerDef} from "./LayerDef";
import {Hill} from "./Hill";
import {HillLists, LayerDefBase} from "./LayerDefBase";
import {Style} from "ol/style";
import {COLOURS} from "./Colours";

export class TopsLayerDef extends LayerDefBase implements LayerDef {
    private visitedStyle = LayerDefBase.buildStyle(
        4,
        COLOURS.MUNRO.VISITED,
        "white",
        1
    );
    private unvisitedStyle = LayerDefBase.buildStyle(
        4,
        COLOURS.MUNRO.UNVISITED,
        "white",
        1
    );

    constructor() {
        super();
        this.isInitiallyVisible = true;
    }

    getProgressElement(): HTMLDivElement {
        return document.getElementById("progress-top") as HTMLDivElement;
    }

    getCountElement(): HTMLDivElement {
        return document.getElementById("count-top") as HTMLDivElement;
    }

    protected getUnvisitedStyle(): Style {
        return this.unvisitedStyle;
    }

    protected getVisitedStyle(): Style {
        return this.visitedStyle;
    }

    protected getLayerHills(hills: HillLists): Hill[] {
        return hills.main.filter((h) => {
            return h.categories.includes("MUNRO_TOP");
        });
    }

    getName(): string {
        return "Munro Tops";
    }
}
